// eslint-disable-next-line no-unused-vars
import { ITool } from 'matrix-requirements-sdk/client';

import { Plugin } from '../Plugin';
import { sdkInstance } from '../Instance';

export class Tool implements ITool {
  /** callback to show or hide the menu for a selected item or folder
   *
   * */
  showMenu(itemId: string) {
    return itemId.indexOf('POST-') == 0;
  }

  /** callback when user executes the custom the menu entry added to items or folders
   *
   * */
  menuClicked(itemId: string) {
    //Get the field id;
    let content = sdkInstance.globalMatrix.ItemConfig.getFieldByName(
      'POST',
      'Blog Post Content',
    );
    try {
      let root = sdkInstance.app.itemForm.find('#fid_' + content.id);
      //@ts-ignore
      let html = $(root.find('.shadow-root')[0].shadowRoot)
        .find('div.shadowedContent')
        .html();
      this.convertAndCopyHtml(html);
    } catch (error) {
      //@ts-ignore
      sdkInstance.ml.UI.showError('Could not copy...', error);
    }
  }
  convertAndCopyHtml(inputHtml: string) {
    // Create a detached div element to hold the input HTML
    const $tempDiv = $('<div>').html(inputHtml);

    // Find all <p> tags and convert them as needed
    $tempDiv.find('p').each(function (inde, element) {
      const pClass = $(element).attr('class');
      if (pClass && pClass.match(/^h[1-6]$/)) {
        const headingLevel = pClass.charAt(1);
        const newHeading = $(
          '<h' + headingLevel + '></h' + headingLevel + '>',
        ).html($(element).html());
        $(element).replaceWith(newHeading);
      }
    });

    // Serialize the manipulated content back to an HTML string
    const resultHtml = $tempDiv.html();
    this.copyToClip(resultHtml);
    sdkInstance.ml.UI.showSuccess('Content copied to clipboard');
  }
  copyToClip(str: string) {
    function listener(e: any) {
      e.clipboardData.setData('text/html', str);
      e.clipboardData.setData('text/plain', str);
      e.preventDefault();
    }
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }
}
